(() => {
  const form = document.getElementById('RuskjaerContactForm');
  if (!form) return;
  const params = new URLSearchParams(location.search);
  const subjects = { b2b: 'B2B / projekt', showroom: 'Showroom og materialeprøver', specialmaal: 'Specialmål', rum: 'Hjælp til mit rum', belysning: 'Belysning', taeppe: 'Tæpper', objekter: 'Objekter og buketter', levering: 'Levering', ordre: 'Eksisterende ordre', reklamation: 'Reklamation' };
  const select = form.elements.namedItem('contact[emne]');
  if (subjects[params.get('emne')] && select) select.value = subjects[params.get('emne')];
  const advisorTopics = {valg:'Valg af bord',stoerrelse:'Størrelse og plads',materialer:'Materialevalg',pleje:'Pleje af træ',laeder:'Pleje af læder',levering:'Levering',ordre:'Min ordre',reklamation:'Skade eller reklamation',belysning:'Valg af belysning',taepper:'Tæppets størrelse',objekter:'Vaser og buketter'};
  const topic = params.get('raadgiver');
  const body = form.elements.namedItem('contact[body]');
  if (advisorTopics[topic] && body && !body.value) {
    body.value = `Jeg har brugt den guidede rådgiver og ønsker personlig hjælp om: ${advisorTopics[topic]}.\n\nProdukt / eventuelt ordrenummer:\nMit spørgsmål:\n`;
    if (select) { const topicSubject={ordre:'Eksisterende ordre',reklamation:'Reklamation',levering:'Levering',belysning:'Belysning',taepper:'Tæpper',objekter:'Objekter og buketter'}; if(topicSubject[topic]) select.value=topicSubject[topic]; }
  }
  const productName = params.get('produkt');
  const variant = params.get('variant');
  const productInput = form.elements.namedItem('contact[produkt]');
  if (productName && productInput) productInput.value = productName.slice(0,200);
  if (productName && body && !body.value) body.value = `Jeg vil gerne have hjælp til ${productName.slice(0,200)}${variant ? ' · ' + variant.slice(0,150) : ''}.\n\nMit spørgsmål:\n\nØnsket leveringstidspunkt:\n`;
  const selection = params.get('udvalg');
  if (selection && body && !body.value) body.value = `Jeg vil gerne have hjælp til at sammensætte mit rum med:\n${selection.slice(0,6000)}\n\nRummets mål:\nMine ønsker og spørgsmål:\n`;
  const roomAdvice = form.querySelector('[data-room-advice]');
  const syncRoomAdvice = () => { if (roomAdvice && select?.value === 'Hjælp til mit rum') roomAdvice.open = true; };
  syncRoomAdvice();
  select?.addEventListener('change', syncRoomAdvice);

  // Only confirmed advisory messages; never clicks, support requests or personal data.
  const leadKey = 'ruskjaer:pending-advice:v1';
  const leadTypes = {'Produkt og materiale':'product','Hjælp til mit rum':'room','Showroom og materialeprøver':'showroom','Specialmål':'custom_size','B2B / projekt':'business','Belysning':'lighting','Tæpper':'rugs','Objekter og buketter':'objects'};
  const analyticsAllowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  form.addEventListener('submit', () => {
    try {
      sessionStorage.removeItem(leadKey);
      const type = leadTypes[select?.value];
      if (type && form.checkValidity() && analyticsAllowed()) sessionStorage.setItem(leadKey, JSON.stringify({type, at: Date.now()}));
    } catch (_) { /* Storage unavailable: form continues normally. */ }
  });
  if (form.querySelector('[data-contact-success]')) {
    let pending;
    try {
      pending = JSON.parse(sessionStorage.getItem(leadKey) || 'null');
      sessionStorage.removeItem(leadKey);
    } catch (_) { pending = null; }
    const age = pending ? Date.now() - pending.at : -1;
    if (pending && Object.values(leadTypes).includes(pending.type) && age >= 0 && age < 1800000) {
      let attempts = 0;
      const publishLead = () => {
        if (!analyticsAllowed()) return;
        if (typeof window.Shopify?.analytics?.publish === 'function') {
          Promise.resolve(window.Shopify.analytics.publish('ruskjaer:advice_submitted', {
            form_id: 'RuskjaerContactForm', lead_type: pending.type
          })).catch(() => {});
        } else if (++attempts < 10) setTimeout(publishLead, 500);
      };
      publishLead();
    }
  }
  const notice = form.querySelector('[role="status"]');
  if (notice) notice.focus();
})();
